var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "head-border" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("img", {
          staticClass: "logo_img",
          attrs: { src: require("@/assets/img/shopvidi_logo.png") },
          on: { click: _vm.gotoShopvidi }
        }),
        _vm._v(" "),
        _c("el-divider", { attrs: { direction: "vertical" } }),
        _vm._v(" "),
        _c("div", { staticClass: "header-content" }, [
          _vm._v("Wholesale Partner Program")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "header-action" }, [
      _c("div", { staticClass: "action black", on: { click: _vm.gotoLogin } }, [
        _vm._v("Login")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action", on: { click: _vm.gotoRegister } }, [
        _vm._v("Sign Up")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42f2b20c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f2b20c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/header.vue
// module id = zuft
// module chunks = 2